/**
 * Dummy data — 알림 (Notifications)
 * API_DOCS: endpoints.notifications / endpoints.admin.notifications
 *
 * NotificationResponse:
 *   id(int), user_id(int), type(string), title(string),
 *   message(string), is_read(boolean), created_at(datetime)
 */

const notifications = [
  { id: 1, user_id: 1, type: 'reservation', channel: 'alimtalk', status: 'sent', title: '예약 확정', message: 'VVT-2026020501 예약이 확정되었습니다.', recipient: '홍길동', is_read: true, created_at: '2026-02-05T09:00:00' },
  { id: 2, user_id: 1, type: 'payment', channel: 'email', status: 'sent', title: '결제 완료', message: '198,000원 결제가 완료되었습니다.', recipient: '홍길동', is_read: true, created_at: '2026-02-05T08:45:00' },
  { id: 3, user_id: 2, type: 'reservation', channel: 'alimtalk', status: 'sent', title: '예약 확정', message: 'VVT-2026020601 골프 이동 예약이 확정되었습니다.', recipient: '김철수', is_read: false, created_at: '2026-02-06T07:00:00' },
];

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/* ── 서비스 (유저용) ── */

/** GET /api/notifications */
export const getNotifications = async (params = {}) => {
  await delay(200);
  let filtered = notifications;
  if (params.user_id) {
    filtered = filtered.filter((n) => n.user_id === Number(params.user_id));
  }
  return filtered;
};

/** PUT /api/notifications/:id/read */
export const markNotificationRead = async (id) => {
  await delay(200);
  const idx = notifications.findIndex((n) => n.id === Number(id));
  if (idx === -1) throw new Error('알림을 찾을 수 없습니다');
  notifications[idx].is_read = true;
  return notifications[idx];
};

/* ── 관리자 ── */

/** GET /api/admin/notifications — 관리자 알림 목록 */
export const getAdminNotifications = async (params = {}) => {
  await delay(300);
  let filtered = [...notifications];
  if (params.channel) filtered = filtered.filter((n) => n.channel === params.channel);
  if (params.status) filtered = filtered.filter((n) => n.status === params.status);
  const page = params.page || 1;
  const size = params.size || 20;
  const total = filtered.length;
  const start = (page - 1) * size;
  return {
    items: filtered.slice(start, start + size),
    total,
    page,
    size,
    pages: Math.ceil(total / size),
  };
};

/** POST /api/admin/notifications/send */
export const sendAdminNotification = async (data) => {
  await delay(400);
  const notification = {
    id: notifications.length + 1,
    user_id: data.user_id || null,
    type: data.type || 'system',
    title: data.title,
    message: data.message,
    is_read: false,
    created_at: new Date().toISOString(),
  };
  notifications.push(notification);
  return { message: '알림이 발송되었습니다' };
};
